import { render } from "./historialPagosError.vue?vue&type=template&id=9639578e"
import script from "./historialPagosError.vue?vue&type=script&lang=js"
export * from "./historialPagosError.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__